<form
  class="field-dialog__content__scroll p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fxLayout="column"
  fusePerfectScrollbar
>
  <div class="card">
    <div
      *ngIf="quotation.labels && quotation.labels.length && hasLabelViewPermission"
      class="mb-16"
      fxLayout="row"
      fxLayout.xs="row wrap"
      fxLayoutAlign="start center"
    >
      <span *ngFor="let label of quotation.labels" class="label" [ngClass]="label.color">
        {{ label.name }}
      </span>
    </div>
    <div class="card__item mt-0">
      <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.STATUS' | translate">
        <span class="{{ quotation.status }}-fg">
          {{ quotation.status | enum: 'quotation_status' }}
        </span>
      </show-data-input>
    </div>
    <div class="card__item">
      <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.COMPANY' | translate">
        <img
          class="avatar-small"
          [src]="quotation.company?.avatarUrl || 'assets/images/avatars/avatar.jpg'"
          [alt]="quotation.company?.name"
        />
        <span>{{ quotation.company?.name || '-' }}</span>
      </show-data-input>

      <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.CREATED_AT' | translate">
        {{ quotation.createdAt | date: 'dd/MM/yyyy HH:mm' }}
      </show-data-input>

      <ng-container *ngIf="quotation.status === 'approved'">
        <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.APPROVED_BY' | translate">
          <img
            class="avatar-small"
            [src]="quotation.approvedBy?.avatarUrl || 'assets/images/avatars/avatar.jpg'"
            [alt]="quotation.approvedBy?.name"
          />
          <span *ngIf="quotation.approvedBy && quotation.approvedBy.name">{{ quotation.approvedBy?.name }}</span>
          <span *ngIf="!quotation.approvedBy && quotation.updatedByName">{{ quotation.updatedByName }}</span>
        </show-data-input>
        <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.APPROVED_AT' | translate">
          {{ (quotation.approvedAt | date: 'dd/MM/yyyy HH:mm') || '-' }}
        </show-data-input>
      </ng-container>

      <ng-container *ngIf="quotation.status === 'refused'">
        <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.REFUSED_BY' | translate">
          <img
            class="avatar-small"
            [src]="quotation.refusedBy?.avatarUrl || 'assets/images/avatars/avatar.jpg'"
            [alt]="quotation.refusedBy?.name"
          />
          <span *ngIf="quotation.refusedBy && quotation.refusedBy.name">{{ quotation.refusedBy?.name }}</span>
          <span *ngIf="!quotation.refusedBy && quotation.updatedByName">{{ quotation.updatedByName }}</span>
          <span class="italic" *ngIf="!quotation.updatedByName && !quotation.refusedBy">{{
            'QUOTATIONS.WITHOUT_IDENTIFICATION' | translate
          }}</span>
        </show-data-input>
        <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.REFUSED_AT' | translate">
          {{ (quotation.refusedAt | date: 'dd/MM/yyyy HH:mm') || '-' }}
        </show-data-input>
      </ng-container>

      <ng-container *ngIf="quotation.status === 'expired'">
        <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.EXPIRED_AT' | translate">
          {{ (quotation.expiredAt | date: 'dd/MM/yyyy HH:mm') || '-' }}
        </show-data-input>
      </ng-container>
    </div>

    <div class="card__item">
      <show-data-input fxFlex="25" [label]="'QUOTATIONS.HEADER.IDENTIFIER' | translate">
        {{ quotation.identifier }}
      </show-data-input>

      <show-data-input fxFlex="75" [label]="'QUOTATIONS.HEADER.LOCATION' | translate">
        {{ quotation.location?.address?.formattedAddress || '-' }}
      </show-data-input>
    </div>

    <div class="card__item">
      <show-data-input
        class="link"
        fxFlex="25"
        [label]="'QUOTATIONS.HEADER.MAINTENANCE_NUMBER' | translate"
        suffix="open_in_new"
        *ngIf="quotation.maintenance"
        (click)="editDialog(quotation.maintenance, !hasEditMaintenancePermission)"
      >
        {{ quotation.maintenance?.number }}
      </show-data-input>
      <show-data-input
        fxFlex="25"
        [label]="'QUOTATIONS.HEADER.MAINTENANCE_NUMBER' | translate"
        *ngIf="!quotation.maintenance"
      >
        -
      </show-data-input>
      <show-data-input fxFlex="37" [label]="'QUOTATIONS.HEADER.MAINTENANCE_TYPE' | translate">
        {{ quotation.maintenance?.maintenanceType?.name || '-' }}
      </show-data-input>
      <show-data-input fxFlex="38" [label]="'QUOTATIONS.HEADER.SEGMENT' | translate">
        {{ quotation.maintenance?.segment?.name || '-' }}
      </show-data-input>
    </div>

    <div class="card__item">
      <show-data-input fxFlex="100" [label]="'QUOTATIONS.HEADER.NAME' | translate">
        {{ quotation.name || '-' }}
      </show-data-input>
    </div>

    <div class="card__item">
      <show-data-input fxFlex="100" [label]="'QUOTATIONS.HEADER.DESCRIPTION' | translate">
        {{ quotation.description || '-' }}
      </show-data-input>
    </div>

    <div class="card__item">
      <show-data-input fxFlex="100" [label]="'QUOTATIONS.HEADER.NOTES' | translate">
        {{ quotation.additionalInformation || '-' }}
      </show-data-input>
    </div>

    <div *ngIf="quotation.status === 'refused' || quotation.status === 'approved'" class="card__item">
      <show-data-input
        data-cy="dialog-quotations-status-message"
        fxFlex="100"
        [label]="
          (quotation.status === 'refused' ? 'QUOTATIONS.HEADER.REFUSED_MESSAGE' : 'QUOTATIONS.HEADER.APPROVED_MESSAGE')
            | translate
        "
      >
        {{ quotation.approvedMessage || '-' }}
      </show-data-input>
    </div>
  </div>

  <ng-container *ngFor="let item of quotation.items; let index = index">
    <div class="card">
      <div class="card__label">{{ 'QUOTATIONS.HEADER.ITEM' | translate }} {{ index + 1 }}</div>

      <div class="card__item">
        <show-data-input fxFlex="10" [label]="'QUOTATIONS.HEADER.ITEM_QUANTITY' | translate">
          {{ item.quantity || '-' }}
        </show-data-input>
        <show-data-input fxFlex="30" [label]="'QUOTATIONS.HEADER.ITEM_NAME' | translate">
          {{ item.productService?.name || '-' }}
        </show-data-input>
        <show-data-input fxFlex="20" [label]="'QUOTATIONS.HEADER.ITEM_CODE' | translate">
          {{ item.productService?.code || '-' }}
        </show-data-input>

        <show-data-input fxFlex="12" [label]="'QUOTATIONS.HEADER.ITEM_TYPE' | translate">
          <ng-container *ngIf="item.productService?.type === 'product'">
            {{ 'QUOTATIONS.HEADER.PRODUCT' | translate }}
          </ng-container>
          <ng-container *ngIf="item.productService?.type === 'service'">
            {{ 'QUOTATIONS.HEADER.SERVICE' | translate }}
          </ng-container>
        </show-data-input>

        <show-data-input class="rtl" fxFlex [label]="'QUOTATIONS.HEADER.ITEM_UNIT_PRICE' | translate">
          {{ (item.productServiceValue | currency: 'BRL') || '-' }}
        </show-data-input>
        <show-data-input class="rtl" fxFlex [label]="'QUOTATIONS.HEADER.ITEM_TOTAL' | translate">
          {{ (item.total | currency: 'BRL') || '-' }}
        </show-data-input>
      </div>

      <div class="card__item mt-10">
        <show-data-input fxFlex="100" [label]="'QUOTATIONS.HEADER.DESCRIPTION' | translate">
          {{ item.description || '-' }}
        </show-data-input>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="hasPaymentsBetaFlag">
    <ng-container *ngFor="let item of quotation.expenses; let index = index">
      <div class="card">
        <div class="card__label">{{ 'QUOTATIONS.HEADER.ITEM' | translate }} {{ index + 1 }}</div>

        <div class="card__item">
          <show-data-input fxFlex="50" [label]="'QUOTATIONS.HEADER.ITEM_NAME' | translate">
            {{ item.expense?.name || '-' }}
          </show-data-input>

          <show-data-input fxFlex="12" [label]="'QUOTATIONS.HEADER.ITEM_TYPE' | translate">
            {{ 'QUOTATIONS.HEADER.EXPENSE' | translate }}
          </show-data-input>

          <show-data-input class="rtl" fxFlex="12" [label]="'QUOTATIONS.HEADER.ITEM_TOTAL' | translate">
            {{ (item.value | currency: 'BRL') || '-' }}
          </show-data-input>

          <show-data-input class="rtl" fxFlex="24">
            <div class="attachment-row">
              <show-data-input class="ltr" [label]="'QUOTATIONS.HEADER.ATTACHMENT' | translate">
                <div class="attachment-item">
                  <span>{{ (item.path | getAttachmentName | maxLength: 10) || '-' }}</span>
                </div>
              </show-data-input>
              <div class="attachment-icon" *ngIf="item.path">
                <i (click)="openReceipt(item)" class="angularjs-fuse-icon icon-eye"></i>
              </div>
            </div>
          </show-data-input>
        </div>

        <div class="card__item mt-10">
          <show-data-input fxFlex="100" [label]="'QUOTATIONS.HEADER.DESCRIPTION' | translate">
            {{ item.description || '-' }}
          </show-data-input>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="card card-total">
    <div class="card__item mt-0" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
      <show-data-input class="rtl" [label]="'QUOTATIONS.HEADER.DISCOUNT' | translate">
        <span class="bold color-red">{{ (quotation?.discount?.total | currency: 'BRL') || '-' }} </span>
      </show-data-input>

      <show-data-input class="rtl" [label]="'QUOTATIONS.HEADER.EXPENSE' | translate" *ngIf="hasPaymentsBetaFlag">
        <span class="bold color-red">{{ (expensesTotalValue | currency: 'BRL') || '-' }} </span>
      </show-data-input>

      <show-data-input class="rtl" [label]="'QUOTATIONS.HEADER.SUB_TOTAL' | translate">
        <span> {{ (quotation?.subTotal | currency: 'BRL') || '-' }}</span>
      </show-data-input>

      <show-data-input class="rtl" [label]="'QUOTATIONS.HEADER.TOTAL' | translate">
        <span class="bold color-green"> {{ (quotation?.total | currency: 'BRL') || '-' }} </span>
      </show-data-input>
    </div>
  </div>
</form>
